import { render } from "./Snackbar.vue?vue&type=template&id=6c348b22&scoped=true"
import script from "./Snackbar.vue?vue&type=script&lang=js"
export * from "./Snackbar.vue?vue&type=script&lang=js"

import "./Snackbar.vue?vue&type=style&index=0&id=6c348b22&scoped=true&lang=scss"

import exportComponent from "/Users/rigun/MyData/project/masehi-kudus/sch-fe-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c348b22"]])

export default __exports__